import { render, staticRenderFns } from "./ProviderDetailsHeader.vue?vue&type=template&id=22940eca&scoped=true&"
import script from "./ProviderDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./ProviderDetailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProviderDetailsHeader.vue?vue&type=style&index=0&id=22940eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22940eca",
  null
  
)

export default component.exports